module.exports = __webpack_public_path__ + "media/red-circle.c5ad048b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/en/images/simple/red-circle.svg
// module id = 889
// module chunks = 0